import { apiPath } from '../_utils/api-version'
import { request } from './http-client'
import { TParams } from './types'

export const getPopups = (
  params: TParams,
  shipper_id?: string,
  platform_id?: string,
  useDynamicLanguage = false
) => {
  return request.get(apiPath('popup', useDynamicLanguage), {
    params,
    headers: {
      Shipper: shipper_id,
      Platform: platform_id,
    },
  })
}

export default getPopups
